<script>
	import thumb__RCqDmnQmJg from '$lib/Components/Youtube/images/_RCqDmnQmJg.jpg?w=610';

	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';

	import LaserCat from './images/laser_cat.jpg';
	import WomanMeasuringWindow from './images/woman_measuring_window_for_indow_window_inserts.jpg';
</script>

<Section>
	<p>
		Lasers can fix eyesight, help accurately hang shelving, aide in epic cat
		playtime, and measure for perfect-fitting custom window inserts.
	</p>
	<Image alt="Laser Cat" src={LaserCat} />
	<p>
		A tape measure will tell you the approximate height and width of a window.
		Our lasers get within 1/32 of an inch. A tape measure also won’t reach into
		corners the way a laser beam will, and it can’t be held taut by one person
		alone. Lasers, clearly the (light)wave of the future, eliminate measurement
		error.
	</p>
	<p>
		We ask for diagonals as well as height and width to get the complete picture
		of your window shape. This tells us if your window frame is out of square.
	</p>
	<p>
		For fun, our CEO measured a window using a measuring tape (not accepted by
		our algorithm) and then our laser measure tool. It might not look like a big
		difference, but it’s enough that on a high-pressure, windy day an insert
		made with the measurements on the left might fall out.
	</p>
	<div
		class="
    flex w-full flex-col justify-around gap-12
    md:flex-row
  "
	>
		<div>
			<p>Measuring Tape:</p>
			<ul>
				<li>Top: 31 1/16″</li>
				<li>Bottom: 31 1/16″</li>
				<li>Left: 50 5/8″</li>
				<li>Right: 50 5/8″</li>
				<li>Bottom L to Top R: 59 3/4″</li>
				<li>Bottom R to Top L: 59 3/4″</li>
			</ul>
		</div>

		<div>
			<p>Laser Measure Tool:</p>
			<ul>
				<li>Top: 31 9/32″</li>
				<li>Bottom: 31 3/16″</li>
				<li>Left: 50 11/16″</li>
				<li>Right: 50 15/16″</li>
				<li>Bottom L to Top R: 59 5/8″</li>
				<li>Bottom R to Top L: 59 1/2″</li>
			</ul>
		</div>
	</div>
</Section>

<Section>
	<h2>Out of Square Window Frames</h2>
	<p>
		As houses settle, window frames settle with them. Neither settle evenly,
		making window frames not perfect squares or rectangles. By getting six laser
		measurements (left, right, top, bottom, 2 diagonals) we get the exact shape
		of your window opening and can create a perfect custom window insert.
	</p>
	<p>
		This isn’t just an issue for historic homes. We’ve made inserts for tens of
		thousands of homes and 95% of them have been significantly out of square.
	</p>
	<p>
		This is the best way to insulate windows because the window insert is
		measured precisely for the window opening. It will have a snug fit and a
		perfect seal all the way around. For our compression system to work
		properly, it has to be even everywhere. If you’re looking for how to seal
		windows for winter, this is the best, most efficient way to do it.
	</p>
	<Image
		alt="Woman Measuring Window for Indow Window Inserts"
		src={WomanMeasuringWindow}
	/>
</Section>

<Section>
	<h2>Laser Measuring is Easy</h2>
	<p>
		All inserts are backed by a Snug Fit Guarantee because of our laser
		measurement system. Here’s how we do it:
	</p>
	<p>
		We send you a laser measure kit with a fun laser measure tool (pew pew). It
		works just like a flashlight—with the press of a button, you <a
			href="/about-indow/how-to-order">get the dimensions</a
		>. Enter the measurements displayed on the tool into our online portal. It
		checks for accuracy.
	</p>
	<p>
		Our fit experts check the measurements for accuracy (again). If everything
		looks good, dimensions are on their way to becoming your custom insert. It’s
		that easy.
	</p>
	<p>
		We developed the tool and software (with error detecting algorithm) because
		it’s the best way we know how to seal windows for winter.
	</p>
	<Youtube
		posterImageSrc={thumb__RCqDmnQmJg}
		src="https://www.youtube.com/embed/_RCqDmnQmJg"
		title="How It’s Made: Indow® Window Inserts"
	/>
</Section>

<Section>
	<h2>Proof Is in the Invisible Windows</h2>
	<p>
		A main benefit of Indow window inserts is they disappear into your window
		frame. We’re able to accomplish this low profile in our compression tubing
		because of our precise measurements. If we had less precise measurements,
		we’d have to create bulkier tubing to accommodate for any small errors. So,
		both performance and aesthetic are ensured by laser measurement.
	</p>
	<p>Hurrah for lasers!</p>
</Section>

<Reviews />
